"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setTransform = void 0;
/**
 * Extract whitelist array. Used by set and string matchers
 */
function setTransform(whitelistObject) {
    return whitelistObject.whitelist;
}
exports.setTransform = setTransform;
